export const money = (cents = 0): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(cents / 100);
export const rate = (value?: number | null): string =>
  value === null || value === undefined ? '—' : `${value.toFixed(1)}%`;
export const share = (part = 0, whole = 0): string => (whole ? rate((100 * part) / whole) : '—');
export const outcomes = [
  { key: 'clean', label: 'Paid without full denial' },
  { key: 'denied', label: 'Full denial' },
  { key: 'other', label: 'Other response' },
  { key: 'pending', label: 'Awaiting response' },
] as const;

export const ageLabels = ['0–30', '31–60', '61–90', '91–120', '121+', 'Unknown'] as const;
